export const toTitleCase = (s: string) =>
    s
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b(\w)/g, (m) => m.toUpperCase());

export const getLowerCase = (value: string) => value.toLowerCase();

export const isEqualString = (value1: unknown, value2: unknown) => {
    return getLowerCase(`${value1}`) === getLowerCase(`${value2}`);
};
